// extracted by mini-css-extract-plugin
module.exports = {"main-component":"selectedTaskCheckBox_main-component__1G8iY"};